import axios from "axios";

function getData(data) {
    return axios.post('api/deduccion/dataTable', data);
}


function guardarDeducion(data) {
    return axios.post('api/deduccion/guardarDeducion', data);
}

function editarDeducion(data) {
    return axios.put('api/deduccion/editarDeducion', data);
}
export {
    getData,
    editarDeducion,
    guardarDeducion
}
